export function isIframeLoaded() {
  return window.self !== window.top;
}